import { formatFixed } from "Util"

const Attractive = ({ data, title }) => {

  function renderingChart(val) {
    if (val > 80) {
      return (
        <div className="chart chart1">
          <img src="/static/images/appeal5.svg" alt="" />
          <em className="txt_darkgreen">{formatFixed(val)}</em>
        </div>
      )
    } else if (val > 55) {
      return (
        <div className="chart chart1">
          <img src="/static/images/appeal4.svg" alt="" />
          <em className="txt_green">{formatFixed(val)}</em>
        </div>
      )
    } else if (val > 45) {
      return (
        <div className="chart chart1">
          <img src="/static/images/appeal3.svg" alt="" />
          <em className="txt_yellow">{formatFixed(val)}</em>
        </div>
      )
    } else if (val > 20) {
      return (
        <div className="chart chart1">
          <img src="/static/images/appeal2.svg" alt="" />
          <em className="txt_orange">{formatFixed(val)}</em>
        </div>
      )
    } else {
      return (
        <div className="chart chart1">
          <img src="/static/images/appeal1.svg" alt="" />
          <em className="txt_red">{formatFixed(val)}</em>
        </div>
      )
    }
  }

  function renderingHistory(title, val) {
    if (val > 80) {
      return (
        <li className="txt_darkgreen">
          <span>{title}</span>
          <em style={{fontSize: 9}}>극단적탐욕</em>
          <strong>{formatFixed(val)}</strong>
        </li>
      );
    } else if (val > 55) {
      return (
        <li className="txt_green">
          <span>{title}</span>
          <em>탐욕</em>
          <strong>{formatFixed(val)}</strong>
        </li>
      );
    } else if (val > 45) {
      return (
        <li className="txt_yellow">
          <span>{title}</span>
          <em>보통</em>
          <strong>{formatFixed(val)}</strong>
        </li>
      );
    } else if (val > 20) {
      return (
        <li className="txt_orange">
          <span>{title}</span>
          <em>공포</em>
          <strong>{formatFixed(val)}</strong>
        </li>
      );
    } else {
      return (
        <li className="txt_red">
          <span>{title}</span>
          <em style={{fontSize: 9}}>극단적공포</em>
          <strong>{formatFixed(val)}</strong>
        </li>
      );
    }
  }

  function renderingComment() {
    if (data.COMMENT > 0) {
      return (
        <dd>
          <strong className="txt_red">상승</strong> 하고 있습니다.
        </dd>
      )
    } else if (data.COMMENT < 0) {
      return (
        <dd>
          <strong className="txt_blue">하락</strong> 하고 있습니다.
        </dd>
      )
    } else {
      return (
        <dd>
          <strong className="txt_gray">횡보</strong> 하고 있습니다.
        </dd>
      )
    }
  }

	return (
    <>
      {renderingChart(data.ATT)}
      <div className="history">
        <ul>
          {renderingHistory('1주 전', data.ATT_W)}
          {renderingHistory('1달 전', data.ATT_M)}
          {renderingHistory('3달 전', data.ATT_3M)}
          {renderingHistory('6달 전', data.ATT_6M)}
        </ul>
      </div>

      <div className="text">
          <dl>
              <dt><img src="/static/images/icon_heart2.svg" alt="" /> {title} :</dt>
              {renderingComment(data.COMMENT)}
              
          </dl>
      </div>
      <div className="tip">* 수준도 중요하지만, <span className="txt_red">절대적인 방향성</span>이 더욱 <span className="txt_red">중요</span>!</div>

      {/* 추가: 연한 회색 구분선과 설명 텍스트 (같은 박스 내 맨 아래) */}
      <div style={{marginTop:14}}>
        <div style={{borderTop: '1px solid #eee'}} />
        <div style={{marginTop:12, color:'#666', lineHeight:1.8}}>
          <div style={{fontWeight:700, color:'#333', marginBottom:0, fontSize:16}}>투자매력도</div>
          <div style={{fontSize:14, fontWeight:600}}>※ 주가의 수준을 측정하여 과열(탐욕)되었는지 위축(공포)되었는지 가늠하는 지표입니다.</div>
          <div style={{fontSize:14, fontWeight:600}}>※ 0에 가까울수록 공포, 100에 가까울수록 탐욕을 나타내며, 탐욕 구간에서는 하락 가능성이, 공포구간에서는 반등 가능성이 높을수 있습니다.</div>
          <div style={{fontSize:14, fontWeight:600}}>※ 단순한 매수/매도 신호보다는 현재 주가의 수준과 방향성을 파악하는 용도로 활용하는 것이 좋습니다.</div>
        </div>
      </div>
    </>
  );
}

export default Attractive;
